import styled from 'styled-components'

export const PageName = styled.h1`
  background: rgba(0, 0, 0, .5);
  color: #ffffff;
  text-align: center;
  padding: 10px 0;
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
`